export const enum ArticleTypeEnum {
    Default = 0,
    Combiniation = 1,
}
